import { lastTransactionsAdapter } from '@api/FW/adapters/transactions/lastTransactions.adapter';
import {  getQueryParams, httpApi } from '@api/FW/http.api';
import {
	LastTransactions,
	LastTransactionsAdapter,
} from '@interfaces/FW/transactions/LastTransactions';

/**
 * Returns last transaction of current user.
 *
 * @param client - user GUID.
 */
export const getLastTransaction = (client: string): Promise<LastTransactions[]> => {
	return httpApi
		.post<LastTransactionsAdapter[]>(
			`LastTransactions/${client}`,
			{
				Ограниченно: 1,
			},
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			return lastTransactionsAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};
